import axiosInstance from '../axios'

export function getVinDecode(vin, auctionCode) {
    return axiosInstance.get('/vin/decode', {
        params: {
            'vin': vin,
            'auctionCode': auctionCode
        }
    })
}

export function designateVin(vin, catalogId) {
    return axiosInstance.post('/vin/designate', {
        vin: vin,
        catalogId: catalogId
    })
}
